import Component from "@glimmer/component";
import { service } from "@ember/service";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { bool } from "prop-types";

import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsLoadingSpinner from "glesys-controlpanel/components/icons/loading-spinner";
import Tour from "glesys-controlpanel/components/tour";

@forbidExtraArgs
export default class DashboardContent extends Component {
  @service modal;
  @service tour;

  @arg(bool) isLoading = false;

  <template>
    <div class="relative bg-gray-50" {{mergeClasses}} ...attributes>
      {{#if this.isLoading}}
        <div class="absolute z-50 top-0 left-0 right-0 bottom-0 bg-gray-50 opacity-60"></div>
        <div class="absolute z-50 top-0 left-0 right-0 bottom-0">
          <div class="flex h-screen mt-[-144px] justify-center">
            <div class="flex items-center -mt-16 -ml-16 mr-12">
              <div class="p-2 rounded-full bg-gray-200">
                <IconsLoadingSpinner class="w-8 text-center text-gray-800" />
              </div>
            </div>
          </div>
        </div>
      {{/if}}

      {{yield}}

      {{#if this.tour.isOpen}}
        <Tour />
      {{/if}}
    </div>
  </template>
}
